import { T, Var } from 'gt-react';
import { AlarmIcon } from '@phosphor-icons/react';
import { Button } from 'src/components/ui/button';

/**
 * Tells a human queue when snoozed tasks are left out, and offers the toggle
 * that brings them back. `included` is the inverse: search or an explicit
 * "show" is listing them, and the same control can hide them again.
 */
export function SnoozeQueueNotice({
  mode,
  hiddenCount,
  onShow,
  onHide,
}: {
  mode: 'hidden' | 'included';
  hiddenCount: number;
  onShow: () => void;
  onHide: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-1.5 text-xs text-amber-950">
      <AlarmIcon className="size-4 shrink-0" />
      <span className="min-w-0 flex-1">
        {mode === 'hidden' ? (
          hiddenCount === 1 ? (
            <T context="banner when one snoozed task is omitted from a human task list">
              1 task is snoozed and hidden from this list.
            </T>
          ) : (
            <T context="banner when snoozed tasks are omitted from a human task list">
              <Var>{hiddenCount}</Var> tasks are snoozed and hidden from this
              list.
            </T>
          )
        ) : (
          <T context="banner when a human task list is including snoozed tasks">
            Snoozed tasks are included in this list.
          </T>
        )}
      </span>
      {mode === 'hidden' ? (
        <Button type="button" variant="outline" size="sm" onClick={onShow}>
          <AlarmIcon className="size-4" />
          <T context="button that includes snoozed tasks in the current list">
            Show Snoozed
          </T>
        </Button>
      ) : (
        <Button type="button" variant="outline" size="sm" onClick={onHide}>
          <AlarmIcon className="size-4" />
          <T context="button that hides snoozed tasks from the current list again">
            Hide Snoozed
          </T>
        </Button>
      )}
    </div>
  );
}
